import './img.less'

import {getResizedUrl, Image, ImageAttrs, m} from '@codeurs/front'
import {forwardRef, Fragment, FunctionComponent, useState} from 'react'
import {ImageLoader, LoaderIcon} from 'views/partials/imageloader'
import {style} from './style'

const styles = style('img')

const supportsObjectFit =
	(window.navigator as any).msMaxTouchPoints === undefined

export const Img: FunctionComponent<
	ImageAttrs & {size?: 's' | 'm' | 'l'}
> = forwardRef(
	(
		{
			type,
			bytes,
			background,
			size = 'l',
			width,
			height,
			position,
			fit,
			style: imgstyle,
			alt,
			onload,
			...rest
		},
		ref
	) => {
		const [isLoaded, setLoaded] = useState(false)
		let src = rest.src
		const extension =
			src &&
			src
				.split('.')
				.pop()
				.split('?')[0]
		const isGif = extension === 'gif'
		if (
			src &&
			extension !== 'gif' &&
			extension !== 'svg' &&
			!src.startsWith('/cache') &&
			src.indexOf('://') === -1
		)
			src = getResizedUrl(
				src,
				size === 's' ? 0 : size === 'm' ? 400 : 600,
				Infinity
			)
		if (isGif && src.indexOf('://') < 0) {
			src = window.location.origin + src
		}
		const crop = fit === 'cover' || fit === 'contain'
		const useBackground = background || (!supportsObjectFit && crop)
		const Tag = useBackground ? 'div' : 'img'
		const focus =
			typeof position === 'string'
				? position
				: position && `${position.x * 100}% ${position.y * 100}%`
		return (
			<Fragment>
				<Tag
					ref={ref as any}
					{...rest}
					{...styles
						.is({crop: crop || background, loaded: isLoaded})
						.mergeProps(rest)}
					{...(useBackground
						? {
								role: 'img',
								'aria-label': alt,
								style: {
									backgroundImage: `url('${src}')`,
									backgroundSize: crop && fit,
									backgroundPosition: focus,
									backgroundRepeat: 'no-repeat',
									...imgstyle
								}
						  }
						: {
								src,
								alt,
								width,
								height,
								style: {
									objectFit: crop && fit,
									objectPosition: focus !== 'center center' && focus,
									...imgstyle
								}
						  })}
					src={src}
					alt={alt || 'Image'}
					onLoad={() => setLoaded(true)}
				/>
				{!isLoaded && <LoaderIcon />}
			</Fragment>
		)
	}
)
